<template>
  <main>
    <div class="main">
      <div class="banner">
        <img
          @click="go"
          style="cursor: pointer"
          src="../../assets/images/banner.png"
        />
      </div>
      <div class="mid">
        <dl class="midLeft">
          <dt>
            <p>学术动态</p>
            <a href="javascript:void 0;" @click.stop="toPage('ArticleList')">
              更多
              <span class="iconfont icon-right1"></span>
            </a>
          </dt>
          <dd
            v-for="(item, index) in articleList"
            v-if="index < 14"
            :key="item.articleId"
          >
            <a
              href="javascript:void 0;"
              @click.stop="toArticleDetailsPage(item.articleId)"
              >{{ item.name }}</a
            >
            <span>{{ item.time.split(" ")[0] }}</span>
          </dd>
        </dl>
        <dl class="midCenter">
          <dt>
            <p>最近讲座</p>
            <a href="javascript:void 0;" @click.stop="toPage('TeachingVideo')">
              更多
              <span class="iconfont icon-right1"></span>
            </a>
          </dt>
          <dd
            @click.stop="toTeachingVideoDetailsPage(item.videoId)"
            v-for="item in videoList"
            :key="item.videoId"
          >
            <div>
              <p class="title">{{ item.name }}</p>
              <p class="name" v-html="item.author"></p>
              <p class="date">{{ item.time }}</p>
            </div>
            <img :src="item.img" />
          </dd>
        </dl>
        <dl class="midRight">
          <dt>
            <p>指南规范</p>
            <a href="javascript:void 0;" @click.stop="toPage('clinical')">
              更多
              <span class="iconfont icon-right1"></span>
            </a>
          </dt>
          <dd
            v-for="(item, index) in activityList"
            v-if="index < 14"
            :key="item.caseId"
            @click.stop="toClinicalDetailsPage(item.id, item)"
          >
            <a href="javascript:void 0;">{{ item.name }}</a>
            <span>{{ item.time }}</span>
          </dd>
        </dl>
      </div>
    </div>
  </main>
</template>
<script>
export default {
  name: "home",
  data() {
    return {
      articleList: [],
      videoList: [],
      activityList: [],
    };
  },
  created() {
    this.getHomeData();
  },
  methods: {
    toClinicalDetailsPage(id, item) {
      if (item.pdfUrl) {
        window.open(item.pdfUrl);
        return;
      }
      this.$router.push({ path: "/ClinincalList?ClinicalId=" + id });
      // let newpage = this.$router.resolve({
      //   path: '/ClinincalList?ClinicalId='+id,
      // })
      // window.open(newpage.href, '_blank');
    },
    getHomeData() {
      this.$api.getVideos({ limit: 3 }).then((r) => {
        if (r.code === 1) {
          this.videoList = r.data;
        }
      });
      this.$api.getAllArticleListByLimit().then((r) => {
        if (r.code === 1) {
          this.articleList = r.data.data;
        } else {
          console.error(r.message);
        }
      });
      this.$api.getClinicalDataList().then((r) => {
        if (r.code === 1) {
          this.activityList = r.data.data;
        } else {
          console.error(r.message);
        }
      });
    },
    toPage(name) {
      this.$router.push({ path: name });
      // let newpage = this.$router.resolve({
      //     name: name,
      // });
      // window.open(newpage.href, '_blank');
    },
    go() {
      this.$router.push({ path: "/teachingvideo/videos?videoId=i0545214" });
    },
    toArticleDetailsPage(id) {
      const src = "/articlelist/article?articleId=" + id;
      this.toDetailsPage(src);
    },
    toTeachingVideoDetailsPage(id) {
      const src = "/teachingvideo/videos?videoId=" + id;
      this.toDetailsPage(src);
    },
    toCaseDetailsPage(id) {
      const src = "/activity/casedetails?caseId=" + id;
      this.toDetailsPage(src);
    },
    toDetailsPage(src) {
      this.$router.push({ path: src });
      /*    let newpage = this.$router.resolve({
                path: src,
            })
            window.open(newpage.href, '_blank');*/
    },
  },
};
</script>
<style lang="scss" scoped>
@import "./Home.scss";
</style>

